import Helmet from 'react-helmet'
import React from 'react'

const SocialMediaTag = ({type, image, title, url, description}) => {

  const meta=[
    {"property": "og:type", "content": `${type}`},
    {"property": "og:image", "content": `${image}`},
    {"property": "og:title", "content": `${title}`},
    {"property": "og:url", "content": `${url}`},
    {"property": "og:description", "content": `${description}`}
  ]

  return <Helmet meta={meta} />
}

export default SocialMediaTag;



// WEBPACK FOOTER //
// ./src/components/SocialMediaTag/index.js